import type { WorkOrderListItem } from "./WorkOrderInterface";

export enum ChangeOrderStatus {
    Open = 1,
    Completed = 2,
    Voided = 3,
    NoCharge = 4
}

export interface ChangeOrderListItem {
    changeOrderID: number;
    jobNumber: string;
    corNumber: number;
    status: number;
    notes: string | null;
    pdfBlobUrl: string | null;
    completedAt: string | null;
    voidedAt: string | null;
    voidReason: string | null;
    noChargeAt: string | null;
    noChargeReason: string | null;
    createdAt: string;
    updatedAt: string | null;
    projectName: string | null;
    workOrderCount: number;
    totalAmount: number;
    missingCONumberCount: number;
}

export interface ChangeOrderHistory {
    changeOrderHistoryID: number;
    changeOrderID: number;
    fromStatus: number | null;
    toStatus: number;
    relatedWorkOrderID: number | null;
    changedByAdminEmployeeID: number | null;
    notes: string | null;
    createdAt: string;
    createdAtOffset: string;
    changedByName: string | null;
    relatedWorkOrderNumber: string | null;
}

export interface ChangeOrderPdfVersion {
    changeOrderPdfVersionID: number;
    changeOrderID: number;
    versionNumber: number;
    pdfBlobUrl: string;
    generatedReason: string;
    generatedByAdminEmployeeID: number | null;
    createdAt: string;
    createdAtOffset: string;
}

// A member work order carries everything a WorkOrderListItem does, incl. coNumber.
export type ChangeOrderMember = WorkOrderListItem;

export interface ChangeOrderDetail extends ChangeOrderListItem {
    completedAtOffset: string | null;
    completedByAdminEmployeeID: number | null;
    voidedAtOffset: string | null;
    voidedByAdminEmployeeID: number | null;
    noChargeAtOffset: string | null;
    noChargeByAdminEmployeeID: number | null;
    createdAtOffset: string;
    updatedAtOffset: string | null;
    createdByAdminEmployeeID: number | null;
    members: ChangeOrderMember[];
    history: ChangeOrderHistory[];
    pdfVersions: ChangeOrderPdfVersion[];
}
